import { createApp } from 'vue';

// 第一层：基础重置样式
import 'normalize.css/normalize.css';

// 第二层：组件库样式 (在自定义样式之前)
import 'vant/lib/index.css';

// 第三层：自定义样式框架
import './styles/tailwind.css';

// 第四层：项目自定义样式 (最高优先级)
import './styles/index.scss';

// svg icon
import 'virtual:svg-icons-register';

import App from './App.vue';
import download from './plugins/download';
import router from './router';
import { store } from './store';
import { usePortalLoginStore } from './store/user';
import { identifyUser, initAnalytics, trackPageView } from './utils/analytics';

// initializeDarkMode();

const app = createApp(App);
app.use(store);
app.use(router);
app.config.globalProperties.$download = download;

initAnalytics();
router.afterEach(to => {
  trackPageView(to.path);
});

// 持久化恢复登录态时补 identify（不打 login_success）
const portalLoginStore = usePortalLoginStore();
const restoredUser = portalLoginStore.portalLogin?.user;
if (restoredUser?.id) {
  identifyUser({
    userId: String(restoredUser.id),
    nickname: restoredUser.nickname,
    userType: restoredUser.type,
  });
}

app.mount('#app');
